import {getUsedMyRefCode} from '../apis/user/getUsedMyRefCode'
import {getPointSummary} from '../apis/point/getPointSummary'
import {getLeaderGraph} from '../apis/leader/getLeaderGraph'
import {getPromotions} from '../apis/promotion/list'

const dashboard = {
    keyId: ['dashboard'] as const,
    getDashboard: (y?: boolean) => [...dashboard.keyId, 'getDashboard', y] as const,
}

const user = {
    keyId: ['user'] as const,
    getUserList: () => [...user.keyId, 'getUserList'] as const,
    getUserDetail: (id?: string) => [...user.keyId, 'getUserDetail', id] as const,
    getUsedMyRefCode: (id?: string) => [...user.keyId, 'getUsedMyRefCode', id] as const,
    getKeyProfile: (keyId?: string) => [...user.keyId, 'getKeyProfile', keyId] as const,
    getUserProfile: (userId?: string) => [...user.keyId, 'getUserProfile', userId] as const,
    getMe: () => [...user.keyId, 'getMe'] as const,
    getProList: (currentPage?: number) => [...user.keyId, 'getProList', currentPage] as const,
    getProHistoryList: () => [...user.keyId, 'getProHistoryList'] as const,
    getProCount: () => [...user.keyId, 'getProCount'] as const,
    getProDetail: (id?: string) => [...user.keyId, 'getProDetail', id] as const,
}

const copier = {
    keyId: ['copier'] as const,
    getCopierList: (id?: string) => [...copier.keyId, 'getCopierList', id] as const,
}

const exchanges = {
    keyId: ['exchanges'] as const,
    exchange: () => [...exchanges.keyId, 'exchange'] as const,
}

const post = {
    keyId: ['post'] as const,
    getPostList: (search_word, current_page) =>
        [...post.keyId, 'getPostList', search_word || '', current_page] as const,
    getPostDetail: (id?: string) => [...post.keyId, 'getPostDetail', id] as const,
}

const announce = {
    keyId: ['announce'] as const,
    getAnnounceList: (currentPage?: number) => [...announce.keyId, 'getAnnounceList', currentPage] as const,
    getAnnounceListMonthly: () => [...announce.keyId, 'getAnnounceListMonthly'] as const,
    getAnnounceDetail: (id?: string) => [...announce.keyId, 'getAnnounceDetail', id] as const,
}

const comment = {
    keyId: ['comment'] as const,
    getCommentList: (search_word, current_page) =>
        [...comment.keyId, 'getCommentList', search_word || '', current_page] as const,
    getCommentDetail: (id?: string) => [...comment.keyId, 'getCommentDetail', id] as const,
}

const recommend = {
    keyId: ['recommend'] as const,
    getRecommend: () => [...recommend.keyId, 'getRecommend'] as const,
}

const league = {
    keyId: ['league'] as const,
    getLeagueList: () => [...league.keyId, 'getLeagueList'] as const,
    getLeagueDetail: id => [...league.keyId, 'getLeagueDetail', id] as const,
    getLeagueShowLeague: () => [...league.keyId, 'getLeagueShowLeague'] as const,
    getLeaguePreviousLeague: () => [...league.keyId, 'getLeaguePreviousLeague'] as const,
}

const tradermap = {
    keyId: ['tradermap'] as const,
    getTraderMapProjects: (active?: boolean) => [...tradermap.keyId, 'getTraderMapProjects', active] as const,
    getTraderMapProjectDetail: id => [...tradermap.keyId, 'getTraderMapProjectDetail', id] as const,
    getTraderMapCampaigns: (active?: boolean) => [...tradermap.keyId, 'getTraderMapCampaigns', active] as const,
    getTraderMapCampaignDetail: id => [...tradermap.keyId, 'getTraderMapCampaignDetail', id] as const,
    getTraderMapVolume: (symbol, user_id, campaign_id) =>
        [...tradermap.keyId, 'getTraderMapVolume', symbol, user_id, campaign_id] as const,
    getTraderMapVolumes: (symbol, period) => [...tradermap.keyId, 'getTraderMapVolumes', symbol, period] as const,
}

// 신규 Volume League (manager-only) admin 모델 키
const volumeLeague = {
    keyId: ['volumeLeague'] as const,
    getVolumeLeagues: () => [...volumeLeague.keyId, 'getVolumeLeagues'] as const,
    getVolumeLeague: () => [...volumeLeague.keyId, 'getVolumeLeague'] as const,
    getVolumeLeagueTrader: (id, trader_id) =>
        [...volumeLeague.keyId, 'getVolumeLeagueTrader', id, trader_id] as const,
}

const logSummary = {
    keyId: ['log'] as const,
    getLogSummaryList: () => [...logSummary.keyId, 'getLogSummaryList'] as const,
    getLogSummary: () => [...logSummary.keyId, 'getLogSummary'] as const,
}
const analysis = {
    keyId: ['stat'] as const,
    getData: (group: string) => [...analysis.keyId, group] as const,
    getIntelligence: (group: string, type: string) => [...analysis.keyId, group, type, 'getIntelligence'] as const,
    getDataStat: () => [...analysis.keyId, 'getDataStat'] as const,
    getCopyDashboard: (limit: number, dataType: string) => [...analysis.keyId, 'getCopyDashboard'] as const,
    getActiveApi: (limit: number) => [...analysis.keyId, 'getActiveApi'] as const,
    getActiveUser: (limit: number) => [...analysis.keyId, 'getActiveUser'] as const,
    getRegisterUser: (limit: number) => [...analysis.keyId, 'getRegisterUser'] as const,
    getAppInstall: (limit: number) => [...analysis.keyId, 'getAppInstall'] as const,
    getGecko: () => [...analysis.keyId, 'getGecko'] as const,
}

const event = {
    keyId: ['event'] as const,
    getEvent: (currentPage, active) => [...event.keyId, `getEvent`, currentPage, active] as const,
    getEventDetail: id => [...event.keyId, 'getEventDetail', id] as const,
}

const news = {
    keyId: ['news'] as const,
    getNews: () => [...news.keyId, 'getNews'] as const,
}

const advertisement = {
    keyId: ['advertisement'] as const,
    getAdvertisement: () => [...advertisement.keyId, 'getAdvertisement'] as const,
    getAdvertisementDetail: id => [...advertisement.keyId, 'getAdvertisementDetail', id] as const,
    getLeaderboardBanner: () => [...advertisement.keyId, 'getLeaderboardBanner'] as const,
    getLeaderboardBannerDetail: id => [...advertisement.keyId, 'getLeaderboardBannerDetail', id] as const,
    getPromotions: (active?: boolean) => [...advertisement.keyId, 'getPromotions', active] as const,
}

const campaign = {
    keyId: ['campaign'] as const,
    getCampaigns: () => [...campaign.keyId, 'getCampaigns'] as const,
    getCampaign: () => [...campaign.keyId, 'getCampaign'] as const,
    getCampaignDetail: id => [...campaign.keyId, 'getCampaignDetail', id] as const,
}

const copyTrading = {
    keyId: ['copyTrading'] as const,
    getLeaders: (exchange, sortBy, currentPage, keyword) =>
        [...copyTrading.keyId, 'getLeaders', exchange, sortBy, currentPage, keyword] as const,
    getLeaderDetail: id => [...copyTrading.keyId, 'getLeaderDetail', id] as const,
    getCopiers: (exchange, filter, sortBy, exchage, currentPage) =>
        [...copyTrading.keyId, 'getCopiers', exchange, filter, sortBy, exchage, currentPage] as const,
    getCopiersDetail: id => [...copyTrading.keyId, 'getCopiersDetail', id] as const,
    getCopierBotRow: (userId, botId, isDeleted) =>
        [...copyTrading.keyId, 'getCopierBotRow', userId, botId, isDeleted] as const,
    getLeadersKeyAll: userId => [...copyTrading.keyId, 'getLeadersKeyAll', userId] as const,
    getInvoices: () => [...copyTrading.keyId, 'getInvoices'] as const,
    getInvoiceData: () => [...copyTrading.keyId, 'getInvoiceData'] as const,
    getLeaderGraph: id => [...copyTrading.keyId, 'getLeaderGraph', id] as const,
}

const devServer = {
    keyId: ['devServer'] as const,
    getDevServer: () => [...devServer.keyId, 'getDevServer'] as const,
}

const wallet = {
    keyId: ['wallet'] as const,
    getWalletTransactions: (id, current_page) => [...wallet.keyId, 'getWalletTransactions', id, current_page] as const,
}

const other = {
    keyId: ['others'] as const,
    getReport: currentPage => [...other.keyId, 'getReport', currentPage] as const,
    getApiLog: (currentPage: number, exchange: string) => [...other.keyId, 'getApiLog', currentPage, exchange] as const,
    getKeyDetail: id => [...other.keyId, 'getKeyDEtail', id] as const,
    getWithdraw: () => [...other.keyId, 'getWithdraw'] as const,
    getWithdrawFailed: () => [...other.keyId, 'getWithdrawFailed'] as const,
    getWithdrawDetail: id => [...other.keyId, 'getWithdrawDetail', id] as const,
    getWithdrawTransaction: id => [...other.keyId, 'getWithdrawTransaction', id] as const,
    getNft: current_page => [...other.keyId, 'getNft', current_page] as const,
    getAbnormalList: current_page => [...other.keyId, 'getAbnormal', current_page] as const,
    getAbnormal: id => [...other.keyId, 'getAbnormal', id] as const,
    getBalanceTimeline: orderId => [...other.keyId, 'getBalanceTimeline', orderId] as const,
}

const point = {
    keyId: ['point'] as const,
    getReferralPoint: (currentPage, pageSize) => [...point.keyId, 'getReferralPoint', currentPage, pageSize] as const,
    getPointSummary: () => [...point.keyId, 'getPointSummary'] as const,
    getUserPointHistory: id => [...point.keyId, 'getUserPointHistory', id] as const,
    getRetractPointHistory: () => [...point.keyId, 'getRetractPointHistory'] as const,
}

const floating = {
    keyId: ['floating'] as const,
    getFloatings: (active?: boolean) => [...floating?.keyId, 'getFloatings', active] as const,
    getFloatingItem: id => [...floating?.keyId, 'getFloatingItem', id] as const,
    getFloatingType: () => [...floating?.keyId, 'getFloatingType'] as const,
}

const payback = {
    keyId: ['payback'] as const,
    getReferrals: () => [...floating?.keyId, 'getReferrals'] as const,
    getReferral: exchange => [...floating?.keyId, 'getReferral', exchange] as const,
    getReward: user_id => [...floating?.keyId, 'getReward', user_id] as const,
}

const landing = {
    keyId: ['landing'] as const,
    getPopups: () => [...landing?.keyId, 'getPopups'] as const,
}

const promotion = {
    keyId: ['promotion'] as const,
    getPromotions: (active?: boolean) => [...promotion.keyId, 'getPromotions', active] as const,
    getPromotionDetail: id => [...promotion.keyId, 'getPromotionDetail', id] as const,
    // 언어별(헤더 강제) 조회 — banner 가져오기 모달 전용
    getPromotionsByLang: (active?: boolean, language?: string) =>
        [...promotion.keyId, 'getPromotionsByLang', active, language] as const,
    getPromotionItems: (id?: string, language?: string) =>
        [...promotion.keyId, 'getPromotionItems', id, language] as const,
}

const badge = {
    keyId: ['badge'] as const,
    getBadges: () => [...badge.keyId, 'getBadges'] as const,
    getBadgeDetail: (id?: string) => [...badge.keyId, 'getBadgeDetail', id] as const,
    getUserBadges: (filter?: object) => [...badge.keyId, 'getUserBadges', filter] as const,
}

const feed = {
    keyId: ['feed'] as const,
    getFeedTemplateKinds: () => [...feed.keyId, 'getFeedTemplateKinds'] as const,
    getFeedTemplates: (kind?: string) => [...feed.keyId, 'getFeedTemplates', kind] as const,
}

export const QueryCacheKeys = {
    dashboard,
    user,
    copier,
    exchanges,
    post,
    comment,
    recommend,
    league,
    event,
    news,
    advertisement,
    other,
    copyTrading,
    logSummary,
    campaign,
    devServer,
    announce,
    analysis,
    wallet,
    point,
    floating,
    payback,
    tradermap,
    volumeLeague,
    landing,
    promotion,
    badge,
    feed,
}
